module.exports = __webpack_public_path__ + "159f495396696d16b19d72e3f9617af2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-winter.png
// module id = 1605
// module chunks = 0